import PageHeader from "../components/sections/PageHeader";
import ProcessTimeline from "../components/sections/ProcessTimeline";
import CTASection from "../components/sections/CTASection";
import Seo from "../components/Seo";

const Process = () => {
  return (
    <div data-testid="process-page">
      <Seo
        title="Manufacturing Process"
        description="PAHI's integrated 12-stage precision manufacturing workflow: raw material, laser cutting, NCT punching, shearing, power press, press brake bending, welding, CNC/VMC machining, powder coating, quality inspection, packing & dispatch."
        path="/process"
      />
      <PageHeader
        eyebrow="Manufacturing Process"
        crumb="Process"
        titleLines={["From raw material", <span key="p" className="text-brand-soft">to dispatch.</span>]}
        subtitle="An integrated 12-stage precision workflow — every component flows seamlessly through cutting, forming, welding, machining, finishing and quality control under one roof."
      />
      <ProcessTimeline withHeader={false} />
      <CTASection />
    </div>
  );
};

export default Process;
